export default {
    en: {
        'base.home': 'Home',
        'admin.company.title': 'Companies',
        'admin.inviraUser.title': 'Invira Users',
        'admin.inviraRole.title': 'Invira User Roles',
        'deposito.title': 'Deposits',
        'menu.administration': 'Administration',
        'menu.userdashboard': 'User Dashboard',
        'menu.customization': 'Customization',
        'user.title': 'Users',
        'role.title': 'Roles',
        'group.title': 'Groups',
    },
    es: {
        'base.home': 'Inicio',
        'admin.company.title': 'Compa??as',
        'admin.inviraUser.title': 'Usuarios Invira',
        'admin.inviraRole.title': 'Roles de Invira',
        'deposito.title': 'Dep?sitos',
        'menu.administration': 'Administraci?n',
        'menu.userdashboard': 'Panel de Usuario',
        'menu.customization': 'Personalizaci?n',
        'user.title': 'Usuarios',
        'role.title': 'Roles',
        'group.title': 'Grupos',
    }
}

